/**
 * Microphone capture. Optional fallback / alternative input for Phase 0.
 */

export type MicSource = {
  output: AudioNode;
  stop: () => void;
  label: string;
};

export async function startMicrophone(ctx: AudioContext): Promise<MicSource> {
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: {
      echoCancellation: false,
      noiseSuppression: false,
      autoGainControl: false,
    },
    video: false,
  });
  const source = ctx.createMediaStreamSource(stream);
  return {
    output: source,
    stop: () => {
      source.disconnect();
      for (const track of stream.getTracks()) track.stop();
    },
    label: 'microphone',
  };
}
